import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-faq',
    templateUrl: './faq.component.html',
    styleUrls: ['./faq.component.sass'],
    standalone: false
})

export class FaqComponent implements OnInit {

  constructor(private translateService: TranslateService, private authService: AuthService) { }

  isAuthenticated(): boolean {
    return this.authService.isAuthenticated();
  }

  ngOnInit(): void {
    this.getFaqHelpDocs();
  }

  getFaqHelpDocs() {
    let language = this.translateService.currentLang.toUpperCase();
    return [
      {
        name: "INTERNET_PROCEDURE_LABEL",
        link: environment.bucket_public_url + `RENAULT KIT FULL INTERNET-PROCEDURE V1.0_${language}.pdf`
      },
      {
        name: "TOKEN_ACTIVATION_PROCEDURE_LABEL",
        link: environment.bucket_public_url + `RNET TOKEN ACTIVATION-PROCEDURE V1.0_${language}.pdf`
      },
      {
        name: "RECYCLE_TOKEN_ACTIVATION_PROCEDURE_LABEL",
        link: environment.bucket_public_url + `RNET RECYCLED TOKEN-ACTIVATION PROCEDURE V1.0_${language}.pdf`
      },
      {
        name: "EURO5_LIMITATION_LABEL",
        link: environment.bucket_public_url + `LIMITATIONS_OF_RENAULT_EURO5_MODULES_${language}_V1.0.pdf`
      },
      {
        name: "EURO5_6_VEHICLE_APPLICABILITY_LABEL",
        link: environment.bucket_public_url + `2025_EURO5-VEH_LIST_V5.3.pdf`
      },
      {
        name: "ADT_EURO_PREREQ_LABEL",
        link: environment.bucket_public_url + `2023_ADT_EURO5_PREREQUIS_${language}_V3.pdf`
      },
    ]
  };

}